import React from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast, showSuccessToast } from "src/ui/shared/toasts/Toasts";

import { updateOauthClient } from "../api/client";

export const useUpdateOauthClient = () => {
    const [isLoading, setIsLoading] = React.useState(false);

    const { t } = useTranslation(["pages"]);

    const onMutate = (clientId: string, client: API.OauthClient, onSuccess: (client: API.OauthClient) => void) => {
        setIsLoading(true);
        void updateOauthClient(clientId, client)
            .then(() => {
                showSuccessToast(t("pages:adminOauthClientsPage.toast.oauthClientUpdatedSuccess"));
                onSuccess(client);
            })
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
    };

    return { isLoading, onMutate };
};
